import { TAppTag } from 'js/components/system/TagManager/types';

import * as Types from './types';
import { actionTypes } from './constants';

export const fetchApp = (
    { app, areInitialResourcesLoaded }: { app: Partial<Types.TRawAppData>; areInitialResourcesLoaded?: boolean }
): Types.IFetchAppAction => ({
    type: actionTypes.APP_FETCH,
    payload: { app, areInitialResourcesLoaded }
});

export const toggleIsAppInitExecuted = (isAppInitExecuted: boolean): Types.IToggleIsAppInitExecutedAction => ({
    type: actionTypes.TOGGLE_IS_APP_INIT_EXECUTED,
    payload: isAppInitExecuted
});

export const updateHeaderHeight = ({ height, decrement }: {
    height: number;
    decrement?: number;
}): Types.IUpdateHeaderHeightAction => ({
    type: actionTypes.UPDATE_HEADER_HEIGHT,
    payload: { height, decrement }
});

export const setAppError = ({ errorText }: {
    errorText: string;
}): Types.ISetAppError => ({
    type: actionTypes.SET_APP_ERROR,
    payload: { errorText }
});

export const setIsQuickDepositAvailable = ({ isQuickDepositAvailable }: {
    isQuickDepositAvailable: boolean;
}): Types.ISetIsQuickDepositAvailableAction => ({
    type: actionTypes.SET_IS_QUICK_DEPOSIT_AVAILABLE,
    payload: { isQuickDepositAvailable }
});

export const addTags = (tags: TAppTag[]): Types.IAddTagsAction => ({
    type: actionTypes.ADD_TAGS,
    payload: tags
});

export const toggleReconnectVisible = (isReconnectVisible: boolean): Types.IToggleReconnectVisibleAction => ({
    type: actionTypes.TOGGLE_RECONNECT,
    payload: isReconnectVisible
});

export const updateMenuItems = (menuItems: Types.IMenuItemConfig[]): Types.IUpdateMenuItemsAction => ({
    type: actionTypes.UPDATE_MENU_ITEMS,
    payload: menuItems
});

export const updateOldGamesFeeds = (oldGamesFeeds: Types.IGameFeedConfig[]): Types.IUpdateOldGamesFeedsAction => ({
    type: actionTypes.UPDATE_OLD_GAMES_FEEDS,
    payload: oldGamesFeeds
});

export const updateSportsbookRootURL = (sportsData: Types.ISportsbookRootURLData): Types.ISportsbookRootURLAction => ({
    type: actionTypes.UPDATE_SPORTSBOOK_ROOT_URL,
    payload: sportsData
});

export const updateLottoRootURL = (lottoData: Types.ILottoRootURLData): Types.ILottoUpdateRootURLAction => ({
    type: actionTypes.UPDATE_LOTTO_ROOT_URL,
    payload: lottoData
});

export const setConfigurationAction = (rgConfig: Types.IResponsibleGamingConfig): Types.IResponsibleGamingConfigAction => ({
    type: actionTypes.SET_RG_CONFIG,
    payload: { rgConfig }
});

export const toggleIsChangeLangInProgress = (isChangeLangInProgress: boolean): Types.IToggleIsChangeLangInProgressAction => ({
    type: actionTypes.TOGGLE_IS_CHANGE_LANG_IN_PROGRESS,
    payload: isChangeLangInProgress
});

export const setIsIntegrationScriptLoadedAction = (isLoaded: boolean): Types.ISetIsIntegrationScriptLoadedAction => ({
    type: actionTypes.SET_IS_INTEGRATION_SCRIPT_LOADED,
    payload: isLoaded
});

export const setIgnoreLogoutNotification = (ignoreLogoutNotification: boolean): Types.ISetIgnoreLogoutNotificationAction => ({
    type: actionTypes.SET_IGNORE_LOGOUT_NOTIFICATION,
    payload: ignoreLogoutNotification
});
